// Timestamp every console.* call (monkey-patch) - keep first so bootstrap logs are stamped
import './utils/consolePatch';
// BODA: Sync runtime config to webpack's process.env - MUST be first import
import './boda-env-sync';
import 'font-awesome/css/font-awesome.min.css';
import "babel-polyfill";
import "raf/polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { StyledEngineProvider } from "@mui/material/styles";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./locales/i18n";
import { LicenseManager } from 'ag-grid-enterprise';
LicenseManager.setLicenseKey(process.env.REACT_APP_AG_LICENCE);

const theme = createTheme({
  palette: {
    primary: {
      light: "#def1ea",
      main: "#0a5d66",
      dark: "#3b5847",
      contrastText: "#fff",
    },
    secondary: {
      light: "#ff7961",
      main: "#4fc3f7",
      dark: "#ba000d",
      contrastText: "#000",
    },
  },
});

ReactDOM.render(
  <React.Fragment>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </StyledEngineProvider>
  </React.Fragment>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();



// WEBPACK FOOTER //
// ./src/index.js